import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/apple-store-small.svg")